import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export type UpsertMaterialPriceArgs = {
    materialId: number;
    price: number;
};

export const shadowUpsertMaterialPrice = async ({ materialId, price }: UpsertMaterialPriceArgs): Promise<void> => {
    try {
        await axios.post(API_URLS.MATERIAL_PRICES_UPSERT, { material_id: materialId, price });
    } catch {
        // The shadow request must not reject the legacy price save.
    }
};
